<div
  class="w-full  bg-white shadow-lg shadow-gray-600/20 h-[88px]  flex flex-row justify-between items-center z-50 fixed top-0 px-[20px]">

  <div class="w-1/3">
    <button *ngIf="eReputationPayment" mat-icon-button
      (click)="routerManagement()" class="bg-[#E8E9EC]">
      <mat-icon class="text-[#223E80]">arrow_back</mat-icon>
    </button>
    <span class="email-mobile"
      style="font-style: italic;color: grey;">{{username}}</span>
    <div *ngIf="eReputationManagement || eReputationPayment"
      class="flex flex-row ml-9 text-sm text-gray-500/50 md:text-[14px] text-[10px]">
      <span
        [ngClass]="eReputationManagement && !eReputationPayment ? 'border-b-2 text-[#223E80] border-[#223E80] bold' : ''">
        {{utils.traslatei18n("onlineReputation.DEALERSHIP_LISTING")}}</span>
      <span class="px-2"> > </span>
      <span [ngClass]="eReputationPayment ? 'border-b-2 text-[#223E80] border-[#223E80] bold' : ''">
        {{utils.traslatei18n("onlineReputation.SUBSCRIPTION")}}</span>
    </div>
  </div>

  <div class="w-1/3 flex justify-center min-w-[100px] items-center">
    <img [src]="logo" alt="focus_logo">
  </div>

  <div class="w-1/3">
    <div class="flex flex-row justify-end items-center">

      <div class=" md:flex flex-row md:mx-5 mt-2"
        *ngIf="!eReputationManagement && !eReputationPayment ">
        <div class="pr-5 flex-row justify-start items-center email-mobile2">
          <span style="font-style: italic;color: grey;">{{username}}</span>
        </div>
        <button mat-icon-button class="md:bg-gray-200 rounded-full theme-color"
          (click)="openDialog('0ms','0ms')">
          <mat-icon class="material-icons">input</mat-icon>
        </button>
      </div>

      <div class="flex flex-row mt-6" *ngIf="languages && languages.length >0">
        <mat-form-field appearance="outline" class="no-border-select"
          >
          <mat-select [formControl]="selectLang" placeholder="Select Language">
            <mat-select-trigger>
              <div class="flex flex-row justify-start items-center"
                *ngIf="selectLang.value">
                <img [src]="selectLang.value?.flag" alt="flag"
                  class="h-4 w-5 mr-2">
                <span>{{utils.traslatei18n(selectLang.value?.viewValue,
                  'language_key')}}</span>
              </div>
              <span *ngIf="!selectLang.value" class="placeholder-text">Select
                Language</span>
            </mat-select-trigger>

            <mat-option *ngFor="let lang of languages" [value]="lang">
              <div class="flex flex-row justify-start items-center">
                <img [src]="lang?.flag" alt="flag" class="h-4 w-5 mr-2">
                <span
                  *ngIf="screen.width>640"
                  class="theme-color font-medium text-sm uppercase underline">{{utils.traslatei18n(lang?.viewValue,
                  'language_key')}}</span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <div class="flex gap-2 flex-row">
          <div class="w-[25px]">
            <img [src]="selectLang.value?.flag" alt="flag">
          </div>
          <span *ngIf="screen.width>640"
            class="theme-color font-medium text-sm uppercase underline">{{utils.traslatei18n(selectLang.value?.viewValue,'language_key')}}</span>
        </div>
        <mat-select class="flex justify-center align-center"
          style="border: 1px solid;" [formControl]="selectLang">
          <mat-select-trigger></mat-select-trigger>
          <mat-option *ngFor="let lang of languages" [value]="lang">
            <div class="flex flex-row justify-start items-center">
              <img [src]="lang?.flag" alt="flag" class="h-full w-5 mr-2">
              <span>{{utils.traslatei18n(lang?.viewValue,
                'language_key')}}</span>
            </div>
          </mat-option>
        </mat-select> -->
        <!-- <mat-form-field appearance="outline" class="language-select">
          <mat-select class="flex justify-center align-center"
            [formControl]="selectLang">
            <mat-option *ngFor="let lang of languages" [value]="lang">
              <div class="flex flex-row justify-start items-center">
                <img [src]="lang?.flag" alt="flag" class="h-4 w-5 mr-2">
                <span>{{utils.traslatei18n(lang?.viewValue,
                  'language_key')}}</span>
              </div>
            </mat-option>
          </mat-select>
        </mat-form-field> -->
      </div>

      <div class="mx-2" *ngIf="eReputationManagement || eReputationPayment ">
        <button mat-icon-button class="md:bg-gray-200 rounded-full theme-color"
          (click)="returnEReputation()">
          <mat-icon class="material-icons">clear</mat-icon>
        </button>
      </div>

    </div>
  </div>

</div>
<div
  class="w-full flex sm:hidden mb-[50px] z-50 fixed top-[70px] bg-white shadow-lg shadow-gray-600/20 pb-[10px]">
  <div *ngIf="eReputationManagement || eReputationPayment"
    class="flex  flex-row ml-4 text-sm text-gray-500/50 md:text-[14px] text-[10px]">
    <div
      [ngClass]="eReputationManagement && !eReputationPayment ? 'border-b-2 text-[#223E80] border-[#223E80] bold' : ''">
      {{utils.traslatei18n("onlineReputation.DEALERSHIP_LISTING")}}</div>
    <div class="px-2"> > </div>
    <div [ngClass]="eReputationPayment ? 'border-b-2 text-[#223E80] border-[#223E80] bold' : ''">
      {{utils.traslatei18n("onlineReputation.SUBSCRIPTION")}}</div>
  </div>
</div>